import $i18n from "./i18n";
export { getPackI18n, getPackLocale, I18n } from "./i18n";
export { setConfig, pandaEvent } from "./services";
export { langList, defaultLangList, zhLangList } from "./const";
export { getOSLang, langToShortLang, formatLang, convertPandaI18nFormatToLocalResource } from "./utils";
export default $i18n;